// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3645":"25dcaf7dbd15f13d","5979":"de322c883845cdd6"}[chunkId] + ".css";
};